<Pagina>
      <h3>Acerca de</h3>
      <!-- <InputCal /> -->
      <InputFecha />
      <Cal />
      <!-- <p>Esta es la página de información sobre la aplicación.</p> -->
</Pagina>

<script>
      import Cal from "./../componentes/basics/Cal.svelte";
      import InputCal from "../componentes/basics/InputCal.svelte";
      import InputFecha from "../componentes/basics/InputFecha.svelte";
      import Pagina from "../componentes/formato/PaginaBase.svelte";
</script>
